import { HttpClient } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import { Store } from '@ngxs/store';
import { isLocalhost } from '@trimble-gcs/common';
import { ClientHeaderService } from '../client-header/client-header.service';
import { TenancyService } from '../tenancy/tenancy.service';
import { LicenseService, LocalhostLicenseService } from './license.service';

export type LicenseServiceOptions = {
  mockWhenLocalhost: boolean;
};

const defaultLicenseServiceOptions: LicenseServiceOptions = {
  mockWhenLocalhost: true,
};

export function provideLicenseService(
  options = defaultLicenseServiceOptions,
): EnvironmentProviders {
  const localhostProviders: Provider[] = [
    {
      provide: LicenseService,
      useClass: LocalhostLicenseService,
      deps: [Store],
    },
  ];

  const realProviders: Provider[] = [
    {
      provide: LicenseService,
      useClass: LicenseService,
      deps: [HttpClient, Store, TenancyService, ClientHeaderService],
    },
  ];

  const { mockWhenLocalhost } = options;
  const providers = mockWhenLocalhost && isLocalhost() ? localhostProviders : realProviders;

  return makeEnvironmentProviders(providers);
}
